<template lang="pug">
div
	router-view
</template>


<script>
import { mapGetters, mapMutations } from 'vuex'
import API from './api'
export default {
	data () {
		return {

		}
	},
	beforeRouteUpdate (to, from, next) {
		this.$store.commit('top/setMenuActivo', to.name)
		next()
	},
	beforeDestroy () {
		this.$store.commit('top/setMenu', [])
	},
	created () {
		const menu = []

		// Menú para insertar un nuevo registro
		menu.push({
			'icono': 'fa fa-plus',
			'nombre': 'Registrar',
			activo: false,
			callback: (a) => {
				this.setMenuActivo(a)
				this.$router.push('/main/horas-extra/editor/nuevo')
			}
		})

		// Menú para consultar mis horas
		menu.push({
			'icono': 'fa fa-user',
			'nombre': 'Mis horas',
			activo: true,
			callback: (a) => {
				this.setMenuActivo(a)
				this.$router.push('/main/horas-extra/usuario/yo')
			}
		})

		// Módulo de estadísticas
		// Menú para el listado de usuarios (si el usuario es un director de equipo)
		// menu.push({
		// 	'icono': 'fa fa-pie-chart',
		// 	'nombre': 'Estadísticas',
		// 	activo: false,
		// 	callback: (a) => {
		// 		this.setMenuActivo(a)
		// 		this.$router.push('/main/horas-extra/estadisticas')
		// 	}
		// })

		// Comprobamos si puede acceder al menú de listados
		API.soyLider()
			.then(res => {
				if (res.data.lider) {
					// Menú para el listado de usuarios (si el usuario es un director de equipo)
					menu.push({
						'icono': 'fa fa-list',
						'nombre': 'Listados',
						activo: false,
						callback: (a) => {
							this.setMenuActivo(a)
							this.$router.push('/main/horas-extra/listado')
						}
					})
				}

				this.setMenu(menu)
			})
			.catch(e => {
				this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		...mapMutations({
			setMenu: 'top/setMenu',
			setMenuActivo: 'top/setMenuActivo'
		})
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/app.vue